import { lazy, Suspense } from "react";

// Defers the TipTap editor (~840KB with prosemirror) into an async chunk —
// it's client-only, so the server renders the null fallback and the editor
// loads after hydration.
const RichTextInputImpl = lazy(() => import("./rich-text-input.impl"));

const RichTextInput = (props) => (
  <Suspense fallback={null}>
    <RichTextInputImpl {...props} />
  </Suspense>
);

export default RichTextInput;
